import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useLocation, Link } from "react-router-dom";
import { RiDeleteBin4Line } from "react-icons/ri";
import { LiaEditSolid } from "react-icons/lia";
import { GrTransaction } from "react-icons/gr";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { GoPlus } from "react-icons/go";
import { CiSearch } from "react-icons/ci";

export const AthleteManage = () => {
  const { staff } = useStaffAuthContext();

  const [athleteData, setAthleteData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [accountType, setAccountType] = useState("");

  const [totalAthletes, setTotalAthletes] = useState(0);

  const [statusFilter, setStatusFilter] = useState("");

  const fetchAthleteData = async (page) => {
    try {
      setIsLoading(true);
      setError("");
      const response = await fetch(
        `${API_URL.GET_ATHLETE_ALL}?page=${page}&limit=500`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        },
      );
      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Failed to fetch data");
      }

      setAthleteData(data.atheletes);
      setFilteredData(data.atheletes);
      setCurrentPage(data.currentPage);
      setTotalPages(data.totalPages);
      setTotalAthletes(data.atheletes.length);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAthleteData(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    filterData(query, accountType, statusFilter);
  };

  const handleAccountTypeChange = (type) => {
    setAccountType(type);
    filterData(searchQuery, type, statusFilter);
  };

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    filterData(searchQuery, accountType, status);
  };

  const filterData = (query, accountType, status) => {
    let filtered = [...athleteData];
  
    if (query.trim() !== "") {
      const lowerQuery = query.toLowerCase();
  
      filtered = filtered.filter(
        (athlete) =>
          athlete.firstname?.toLowerCase().includes(lowerQuery) ||
          athlete.lastname?.toLowerCase().includes(lowerQuery) ||
          athlete.email?.toLowerCase().includes(lowerQuery) ||
          athlete.city?.toLowerCase().includes(lowerQuery) ||
          athlete.gender?.toLowerCase().includes(lowerQuery),
      );
    }
  
    if (accountType) {
      filtered = filtered.filter(
        (athlete) => athlete.account_type === accountType,
      );
    }
  
    if (status) {
      filtered = filtered.filter(
        (athlete) => athlete.status === status,
      );
    }
  
    setFilteredData(filtered);
    setTotalAthletes(filtered.length);
  };

  const deleteAthlete = async (id) => {
    if (window.confirm("Are you sure you want to delete this athlete?")) {
      try {
        setIsDeleting(true);
        const response = await fetch(`${API_URL.DELETE_ATHLETE}/${id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });
        const data = await response.json();

        if (!response.ok) {
          setError(data.error || "Failed to delete athlete");
        }

        fetchAthleteData(currentPage);
        alert("Athlete deleted successfully!");
      } catch (err) {
        alert(`Error deleting athlete: ${err.message}`);
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const ACCOUNT_TABS = [
    { label: "All", value: "" },
    { label: "Access", value: "FREE PLAN" },
    { label: "Programs", value: "STATIC PLAN" },
    { label: "Coached", value: "AMAX COACHED" },
  ];

  const getAccountLabel = (value) => {
    const match = ACCOUNT_TABS.find((tab) => tab.value === value);
    return match ? match.label : value;
  };

  return (
    <div className="flex md:h-dvh">
      <StaffSideMenu />

      <div className="max-md:w-full md:flex-1 md:flex md:flex-col md:overflow-hidden md:overflow-y-auto bg-bgBase p-5 md:pt-10 md:px-10 min-w-0">
        <div className="w-full flex flex-col justify-between gap-6 mb-8">
          <h1 className="font-inter font-medium text-dark  text-2xl md:text-3xl !leading-none max-md:pl-14">
            Athletes
          </h1>

          <div className="flex gap-3 sm:gap-6 border-b border-tblBorder">
            {ACCOUNT_TABS.map((tab) => (
              <button
                key={tab.value}
                onClick={() => handleAccountTypeChange(tab.value)}
                className={`pb-3 text-sm font-inter font-medium leading-none border-b-2 border-transparent hover:text-dark hover:border-dark transition ${
                  accountType === tab.value
                    ? "!border-darkYellow text-dark"
                    : "text-slate100"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* total athlete / tabs */}
        <div className="w-full flex max-lg:flex-col justify-between lg:items-center gap-6 mb-8">
          {/* total athlete */}
          <p className="font-inter font-normal text-sm text-slate100">
            <span className="block font-inter font-semibold text-4xl text-dark leading-none mb-1">
              {totalAthletes}
            </span>
            Total athletes
          </p>

          {/* search */}
          {/* add customer btn */}
          <div className="flex flex-wrap md:items-center gap-3">
            <div className="relative w-full min-w-64 max-w-64">
              <input
                type="text"
                placeholder="Search athletes..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-sm pl-10"
              />
              <span className="absolute top-1/2 -translate-y-1/2 left-3">
                <CiSearch color="#666666" size={20} />
              </span>
            </div>

            {/*<button className="bg-dark rounded-10 py-2.5 px-4 flex items-center gap-2 text-white font-inter font-medium whitespace-nowrap hover:bg-black">
              <GoPlus color="#fff" size={16} className="-mb-px" /> Add new
              customer
            </button>*/}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {[
            { label: "All", value: "" },
            { label: "Lead", value: "Lead" },
            { label: "Follow Up", value: "Follow Up" },
            { label: "Pending", value: "Pending" },
            { label: "Member", value: "Member" },
            { label: "Cancelled", value: "Cancelled" },
            { label: "Inactive", value: "Inactive" },
          ].map((status) => (
            <button
              key={status.value}
              onClick={() => handleStatusChange(status.value)}
              className={`py-2.5 px-4 rounded-full font-inter font-medium text-sm leading-tight border transition ${
                statusFilter === status.value
                  ? "bg-dark border-dark text-white"
                  : "bg-white border-tblBorder text-slate100 hover:bg-black hover:text-white"
              }`}
            >
              {status.label}
            </button>
          ))}
        </div>

              <br></br>
        {/* table / pagination */}
        <div className="w-full mb-8">
          <div className="overflow-auto show-scrollbar max-h-[550px]">
            <div className="rounded-10 border border-tblBorder w-full">
              <table className="table-auto table-radius w-full min-w-[768px]">
                <thead className="sticky top-0 bg-tblHead border-b border-tblBorder">
                  <tr className="text-slate100 font-inter !font-medium text-xs md:text-sm uppercase">
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Created
                    </th>
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Name
                    </th>
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Email
                    </th>
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Phone
                    </th>
                   {/* <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Account Type
                    </th>
                    */}
                     <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Status
                    </th> 
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Membership
                    </th>
                 
                    {/* <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">Speed Workout(OLD)</th>
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">Strength Workout(OLD)</th>
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">Runrocket/LoadVelocity</th> */}
                    <th className="py-1.5 md:py-3 px-3 md:px-6 text-left">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#E5E5E5]">
                  {isLoading ? (
                    <tr className="font-inter font-normal text-dark text-xs md:text-sm">
                      <td colSpan="8" className="text-center py-4">
                        <p className="text-blue-600">Loading data...</p>
                      </td>
                    </tr>
                  ) : error ? (
                    <tr className="font-inter font-normal text-dark text-xs md:text-sm">
                      <td colSpan="8" className="text-center py-4">
                        <p className="text-red-600">{error}</p>
                      </td>
                    </tr>
                  ) : filteredData.length === 0 ? (
                    <tr className="font-inter font-normal text-dark text-xs md:text-sm">
                      <td colSpan="8" className="text-center py-4">
                        <p>No records found</p>
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((athlete, index) => (
                      <tr
                        key={athlete._id}
                        className={`bg-white font-inter font-normal text-slate100 text-xs md:text-sm`}
                      >
                        <td className="px-3 md:px-6 py-2 md:py-4 whitespace-nowrap">
                          <span className="inline-block pr-2">
                            {new Date(athlete.createdAt).toLocaleDateString()}
                          </span>
                          <span>
                            {new Date(athlete.createdAt).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              },
                            )}
                          </span>
                        </td>

                         {/* Name */}
                        <td className="px-3 md:px-6 py-2 md:py-4 font-medium text-dark">
                          <Link
                            to={`/administrator/athlete/warmup-routine/${athlete._id}`}
                            className="hover:underline hover:text-black"
                          >
                            {athlete.firstname} {athlete.lastname}
                          </Link>
                        </td>

                        {/* Email */}
                        <td className="px-3 md:px-6 py-2 md:py-4">
                          {athlete.email}
                        </td>

                        {/* Phone */}
                        <td className="px-3 md:px-6 py-2 md:py-4">
                          {athlete.phonenumber || "-"}
                        </td>


                        <td className="px-3 md:px-6 py-2 md:py-4">
                            {athlete.status || "-"}
                        </td>

                        <td className="px-3 md:px-6 py-2 md:py-4">
                        {getAccountLabel(athlete.account_type)}
                        </td>

                        <td className="px-3 md:px-6 py-2 md:py-4">
                          <div className="flex gap-2">
                            <Link
                              to={`/administrator/athlete/edit/${athlete._id}`}
                              className="p-2 rounded-md hover:bg-slate-100"
                            >
                              <LiaEditSolid color="#666666" size={20} />
                            </Link>
                            <button
                              onClick={() => deleteAthlete(athlete._id)}
                              className="p-2 rounded-md hover:bg-slate-100"
                              disabled={isDeleting}
                            >
                              <RiDeleteBin4Line color="#666666" size={20} />
                            </button>
                            {/* Conditionally render Test Results and Transactions for athletes who are not on the "FREE PLAN" */}
                            {/*athlete.account_type !== "FREE PLAN" && (
                              <Link
                                to={`/administrator/athlete/payment-transactions/${athlete._id}`}
                                className="p-2 rounded-md hover:bg-slate-100"
                              >
                                <GrTransaction color="#666666" size={20} />
                              </Link>
                            )*/}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="w-full flex max-sm:flex-col justify-center sm:justify-between items-center mt-auto pt-2">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
              currentPage === 1 ? "cursor-not-allowed" : "text-black"
            }`}
          >
            <MdKeyboardArrowLeft size={20} /> Previous
          </button>
          <p className="text-dark font-inter font-normal text-sm ">
            Page {currentPage} of {totalPages}
          </p>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
              currentPage === totalPages ? "cursor-not-allowed" : "text-black"
            }`}
          >
            Next <MdKeyboardArrowRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};
